import {
  AfterViewInit,
  Component,
  HostListener, signal,
} from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import {
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { Location } from '@angular/common';
import { AuthService } from 'src/app/shared/services/auth.service';
import {ProfileSettingsComponent} from "./components/profile-settings/profile-settings.component";
import {AuthDataComponent} from "./components/auth-data/auth-data.component";
import {LinkedAccountComponent} from "./components/linked-account/linked-account.component";

type ActiveAction = 'menu'
  | 'profileSettings'
  | 'authData'
  | 'linkAccount'
  | 'deleteAccount';

@Component({
  selector: 'app-profile-settings-modal',
  imports: [
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    ProfileSettingsComponent,
    AuthDataComponent,
    LinkedAccountComponent,
  ],
  templateUrl: './profile-settings-modal.component.html',
  styleUrl: './profile-settings-modal.component.scss',
  standalone: true,
})
export class ProfileSettingsModalComponent implements AfterViewInit {
  @HostListener('document:click', ['$event'])
  click(event: MouseEvent) {
    if (
      // @ts-ignore
      event.target?.classList.contains('btn-back') &&
      event.clientX < window.outerWidth / 2
    ) {
      this.activeAction.set('menu');
      return;
    }
    // @ts-ignore
    if (event.target?.classList.contains('outer-close')) {
      this.$dialogRef.close();
      const pathWithoutHash = this.$location.path().split('#')[0];
      this.$location.replaceState(pathWithoutHash);
    }
  }

  lang = this.$t.getDefaultLang();

  activeAction = signal<ActiveAction>('menu');

  constructor(
    private $dialogRef: MatDialogRef<ProfileSettingsModalComponent>,
    private $http: HttpClient,
    public $t: TranslateService,
    private $location: Location,
    private $auth: AuthService,
  ) {}

  ngAfterViewInit() {
    document.getElementsByClassName('btn-back')[0]?.classList.add('hideBefore');
  }

  getTitle(): string {
    switch (this.activeAction()) {
      case 'menu':
        document
          .getElementsByClassName('btn-back')[0]
          ?.classList.add('hideBefore');
        document
          .getElementsByClassName('btn-back')[0]
          ?.classList.remove('hideAfter');
        return 'menu.profile';
      case 'profileSettings':
        document
          .getElementsByClassName('btn-back')[0]
          ?.classList.remove('hideBefore');
        document
          .getElementsByClassName('btn-back')[0]
          ?.classList.add('hideAfter');
        return 'profilePage.profileSettings';
      case 'authData':
        document
          .getElementsByClassName('btn-back')[0]
          ?.classList.remove('hideBefore');
        document
          .getElementsByClassName('btn-back')[0]
          ?.classList.add('hideAfter');
        return 'profilePage.authData';
      case 'linkAccount':
        document
          .getElementsByClassName('btn-back')[0]
          ?.classList.remove('hideBefore');
        document
          .getElementsByClassName('btn-back')[0]
          ?.classList.add('hideAfter');
        return 'profilePage.linkAccount';
      case 'deleteAccount':
        document
          .getElementsByClassName('btn-back')[0]
          ?.classList.remove('hideBefore');
        document
          .getElementsByClassName('btn-back')[0]
          ?.classList.add('hideAfter');
        return 'profilePage.deleteProfileTitle';
      default:
        document
          .getElementsByClassName('btn-back')[0]
          ?.classList.remove('hideBefore');
        document
          .getElementsByClassName('btn-back')[0]
          ?.classList.add('hideAfter');
        return 'menu.profile';
    }
  }

  deleteUser() {
    this.$http
      .delete('auth/account', {
        params: {
          isSSO: true,
        },
      })
      .subscribe(() => {
        this.$auth.logOut();
      });
  }
}
